import CloseIcon from '@mui/icons-material/Close';
import { Fab } from '@mui/material';
import { ReactComponent as ChatIcon } from 'assets/icons/Chat.svg';

import { styles } from './ChatButton.styles';

interface ChatButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const ChatButton: React.FC<ChatButtonProps> = ({ isOpen, onClick }) => {
  return (
    <Fab aria-label="chat" color="primary" onClick={onClick} sx={styles.button}>
      {isOpen ? <CloseIcon style={{ fontSize: 30 }} /> : <ChatIcon />}
    </Fab>
  );
};
